import { onLocalEvent } from "./api";
import { subscribeLive } from "./liveRealtime";

export function subscribeRealtime({
  topics = ["market"],
  marketId = "",
  marketIds = [],
  onMarketUpdate,
  onLeaderboardsUpdate,
  onCommentsUpdate
} = {}) {
  const safeCall = (fn) => {
    if (typeof fn !== "function") return;
    Promise.resolve(fn()).catch(() => null);
  };

  const unsubLocal = onLocalEvent((event) => {
    if (event.type === "market_updated" && matchesMarket(event.marketId, { marketId, marketIds })) {
      safeCall(onMarketUpdate);
    }
    if (event.type === "leaderboards_updated") {
      safeCall(onLeaderboardsUpdate);
    }
    if (event.type === "market_comments_updated" && matchesMarket(event.marketId, { marketId, marketIds })) {
      safeCall(onCommentsUpdate);
    }
  });

  const unsubLive = subscribeLive({
    topics,
    marketId,
    marketIds,
    onMarketUpdate,
    onLeaderboardsUpdate,
    onCommentsUpdate,
    onStatusChange: (status) => {
      if (import.meta.env.VITE_DEBUG_REALTIME === "1") {
        console.debug("[realtime]", { topics, marketId, marketIds, status });
      }
    }
  });

  return () => {
    unsubLocal();
    unsubLive();
  };
}

function matchesMarket(eventMarketId, { marketId, marketIds }) {
  const normalized = String(eventMarketId || "");
  if (!normalized) return false;
  const scopedMarketIds = Array.isArray(marketIds) ? marketIds.map(String) : [];
  if (!marketId && scopedMarketIds.length === 0) return true;
  if (marketId && normalized === String(marketId)) return true;
  return scopedMarketIds.includes(normalized);
}
